import {Checkbox, Spin} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import React, {useState} from "react";
import {aggregateSeverity, computeSeverity, getSeverityColor} from "./run-project/operationStatus";

export const OPS_STATUS = {
    NOT_CHECK: 0,
    CHECKING: 1,
    COMPLETED: 2,
    ERROR: 3,
}

const OperationGroup = ({}) => {

}

const OperationItem = ({}) => {

}

const disabledColor = '#888888'
const normalColor = '#0f0f0f'
const selectedColor = '#01a3a4'
const showKey = true

const isCompleted = (item) => item?.status === OPS_STATUS.COMPLETED

export default function OperationMenu({operations = [], onCheckedChanged, onClick, disableCheck, selected}) {
    const [expand, setExpand] = useState([])

    const onCheckAll = (title, val) => {
        const items = [...operations.find(x => x.title === title).children]
        onCheckedChanged && onCheckedChanged([...items], val)
    }

    // Color of a single operation item, driven by its severity (see
    // operationStatus.js). Severity is computed from the operation's own
    // message codes, so it is correct for both fresh and history runs.
    const itemColor = (item) => {
        if(item?.disabled)
            return disabledColor

        if(!isCompleted(item))
            return normalColor

        return getSeverityColor(computeSeverity(item))
    }

    // Color of a group header: the worst severity among its completed
    // children (gray if disabled, black until something completes).
    const headerColor = (op) => {
        if(op?.disabled)
            return disabledColor

        if(!op?.children?.some(isCompleted))
            return normalColor

        return getSeverityColor(aggregateSeverity(op?.children, isCompleted))
    }

    const renderHeader = (op, idx) => {
        const checked = op?.children?.filter(item => item.enable).length === op?.children?.length;
        const intermediate = op?.children?.filter(item => item.enable).length > 0;

        let time = 0;
        op?.children?.forEach(x => x.time && (time += x.time))

        return (
            <div
                onClick={() => {
                    const key = op?.title
                    if(expand.find(x => x === key))
                        setExpand(expand.filter(x => x !== key))
                    else
                        setExpand([...expand, key])
                }}
                style={{display: 'flex', alignItems: 'center', gap: 8, padding: 4, backgroundColor: 'rgb(230, 238, 242)'}}
            >
                <div onClick={(e) => {e.stopPropagation()}}>
                    {
                        !disableCheck && (
                            <Checkbox
                                disabled={op?.disabled}
                                checked={checked}
                                indeterminate={!checked && intermediate}
                                onChange={(e) => {
                                    onCheckAll(op?.title, e.target.checked)
                                }}
                            />
                        )
                    }
                </div>
                <span style={{color: headerColor(op)}}>
                    {`${op?.title}`} ({time?.toFixed(1)} s)
                </span>
            </div>
        )
    }

    return (
        <div style={{display: 'flex', alignItems: 'start', flexWrap: 'wrap', gap: 16}}>
            {
                operations.map((op, idx) => {
                    return (
                        <div
                            style={{border: '1px solid #cfcfcf', borderRadius: 2, width: 350, paddingBottom: 8, height: 235}}
                            key={op?.title}
                        >
                            {renderHeader(op, idx)}
                            <div style={{marginLeft: 12, marginRight: 12}}>
                                {
                                    op?.children?.map((item, idy) => {
                                        return (
                                            <div style={{display: 'flex', gap: 4, alignItems: 'center'}}>
                                                <div style={{flex: 1}}>
                                                    {
                                                        !disableCheck && (
                                                            <Checkbox
                                                                style={{marginRight: 4}}
                                                                disabled={item.disabled}
                                                                checked={item.enable}
                                                                onChange={(e) => {
                                                                    if (item.disabled)
                                                                        return

                                                                    onCheckedChanged([item], e.target.checked)
                                                                }}
                                                            />
                                                        )
                                                    }
                                                    <a
                                                        onClick={() => {
                                                            if (item.disabled)
                                                                return

                                                            onClick(item)
                                                        }}
                                                        style={{
                                                            flex: 1,
                                                            color: itemColor(item),
                                                            fontWeight: item.title === selected?.title ? 'bold': ''
                                                        }}
                                                    >
                                                        {item.title} {item.title === selected?.title ? <>&#x2022;</> : ''}
                                                    </a>
                                                </div>
                                                {item.status === OPS_STATUS.CHECKING && (<Spin size={'small'}/>)}
                                                {item.status === OPS_STATUS.ERROR && (<CloseOutlined />)}
                                                <div>
                                                    {showKey && (`(${item.key_text || item.key})`)}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}